import * as React from 'react';
import styled from 'styled-components';
import {FileObject, getImageByPreview} from 'api/library';
import FileContainer from '../components/FileContainer';

export interface ColumnProps {
  value: FileObject['id'];
}

const Container = styled.div`
  margin: 0 35px;
  height: 400px;
  max-width: 690px;
  width: 100%;

  @media screen and (max-width: 768px) {
    height: 240px;
    margin: 0 12px;
  }
`;

const Image = styled.img`
  border-radius: 5px;
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

/**
 *
 * @param {ColumnProps} props
 * @return {React.ReactElement<ColumnProps>}
 * @constructor
 */
export default function Column(
    props: ColumnProps,
): React.ReactElement<ColumnProps> {
  return (
    <Container>
      <FileContainer id={props.value}>
        {(file) => (
          <Image
            src={getImageByPreview({
              id: file.id,
              type: file.type,
              url: file.url,
            })}
          />
        )}
      </FileContainer>
    </Container>
  );
}
